import SignUpPage from 'common/components/Authentication/SignUpPage'
import LogInPage from 'common/components/Authentication/LogInPage'
import SignoutPage from 'common/components/Authentication/SignoutPage'
import ForgottenPasswordPage from 'common/components/Authentication/ForgottenPasswordPage'
import ResetPasswordPage from 'common/components/Authentication/ResetPasswordPage'
import ResetPasswordSuccessPage from 'common/components/Authentication/ResetPasswordSuccessPage'
import VerifyEmailPage from 'common/components/Authentication/VerifyEmailPage'
import EnableMFAPage from './cwp-components/MFA/SetUpMFA'
import { DataSourcePage } from './cwp-components/CWP Sections/DataSource/DataSource'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useAuth } from 'common/providers/useAuth'
import useProfile from 'common/providers/useProfile'
import Project from 'common/project'

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
  Outlet,
} from 'react-router-dom'
import ContactPage from '../src/cwp-components/Contact'
import GetTheAppPage from '../src/cwp-components/GetTheAppPage'
import BlogPage from 'cwp-components/BlogPage'
import LawPage from './cwp-components/LawPage'
import PublicContent from './cwp-components/Public Content/PublicContent'
import LawFirmResults from './cwp-components/CWP Sections/lawfirm/LawFirmResults'
import BookALayer from 'cwp-components/BookALayer'
import JoinOurNetwork from './cwp-components/JoinOurNetwork'
import { useEffect } from 'react'
import { Amplify, Auth, Hub } from 'aws-amplify'
import LawfirmMembersList from 'cwp-components/CWP Sections/lawfirm/LawfirmMembersList'
import BlogPostView from '../src/cwp-components/CWP Sections/LegalDocuments/BlogPostView'
import {
  getAuthRedirectCookie,
  removeAuthRedirectCookie,
} from 'common/utils/redirects'
import LegalDocumentDownload from './cwp-components/LegalDocumentDownload'
import AppLayout from 'cwp-components/layouts/AppLayout'
import {
  AccountVerification,
  Appointments,
  ArticleDetail,
  Articles,
  BarristerCreation,
  Blog,
  ChamberCreation,
  ChamberManagerCreation,
  ComplaintAssistance,
  DiscoverLaw,
  DocumentLibrary,
  Episode,
  Error,
  FindALawyerIntelligence,
  FindALawyerIntelligenceSearch,
  HomePage,
  Interviews,
  LawFirmCreation,
  LawFirmCreationDetails,
  LawFirmManagerCreation,
  LegalDocuments,
  LegalDocumentTemplate,
  LegalField,
  LegalTermsGlossary,
  Ourapp,
  Podcasts,
  TermsAndPolicies,
  Pricing,
  PricingLawyers,
  Profile,
  ProfileCreation,
  ProfileOfficeList,
  SolicitorCreation,
  SolicitorCreationDetails,
  SolicitorManagerCreation,
  WhoWeAre,
  TermsAndPoliciesItem,
  LegalSubField,
  Favourites,
  ViewTeamProfiles,
  LearnMorePage,
  OurMission,
  OurStoryPage,
} from './pages'
import TopLegalDocuments from 'pages/legal-documents/TopLegalDocuments'
import { MemberProfileExtendedPage } from 'pages/member-profile-extended/MemberProfileExtendedPage'

Amplify.configure(Project.cognitoWeb)
Auth.configure(Project.cognitoWeb)

if (typeof window !== 'undefined') {
  const wfa_pstMesgFrmFom = (evt) => {
    if (
      evt.origin === 'https://crm.zoho.eu' ||
      evt.origin === 'https://crm.zohopublic.eu'
    ) {
      const loc_obj = JSON.stringify({
        origin: window.location.origin,
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
      })
      evt.source.postMessage(
        'prnt_wnd_pg_lc_rc_frm_prwindow_' + loc_obj,
        evt.origin,
      )
    }
  }
  window.addEventListener('message', wfa_pstMesgFrmFom, false)
}

const ScrollToTop = () => {
  const location = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return null
}

function App() {
  const user = useAuth()
  const { getProfile } = useProfile()

  useEffect(() => {
    getProfile({})
  }, [])

  useEffect(() => {
    Hub.listen('auth', (data) => {
      if (data.payload.event === 'signIn') {
        getProfile({
          onSuccess: (data) => {
            const authRedirectCookie = getAuthRedirectCookie()

            if (authRedirectCookie) {
              removeAuthRedirectCookie()
              document.location = authRedirectCookie

              return
            }

            document.location =
              data?.fullName || data.first_name
                ? '/find-a-lawyer/search'
                : '/profile'
          },
        })
      }
    })
  }, [])

  const ProtectedRoute = ({ isAuthenticated }) => {
    return isAuthenticated ? <Outlet /> : <Navigate to='/login' replace />
  }

  return (
    <div className='App h-full'>
      <GoogleReCaptchaProvider reCaptchaKey={Project.recaptchaSiteKey}>
        <Router>
          <ScrollToTop />
          <AppLayout>
            <Routes>
              <Route path='/pages/:slug' element={<BlogPage />} />
              <Route
                path='/terms-and-policies'
                element={<TermsAndPolicies />}
              />
              <Route
                path='/terms-and-policies/:id'
                element={<TermsAndPoliciesItem />}
              />
              <Route path='/learn-more' element={<LearnMorePage />} />
              <Route path='/articles' element={<Articles />} />
              <Route path='/blog/:slug' element={<Blog />} />
              <Route path='/contact-us' element={<ContactPage />} />
              <Route path='/discover-law' element={<DiscoverLaw />} />
              <Route path='/podcasts' element={<Podcasts />} />
              <Route path='/podcasts/:id' element={<Episode />} />
              <Route path='/legal-field/:area' element={<LegalField />} />
              <Route
                path='/legal-sub-field/:area'
                element={<LegalSubField />}
              />
              <Route path='/mfa' element={<EnableMFAPage />} />
              <Route path='/verify-email' element={<VerifyEmailPage />} />
              <Route
                path='/forgot-password'
                element={<ForgottenPasswordPage />}
              />
              <Route path='/login' element={<LogInPage />} />
              <Route path='/reset-password' element={<ResetPasswordPage />} />
              <Route
                path='/reset-password/success'
                element={<ResetPasswordSuccessPage />}
              />
              <Route path='/interviews' element={<Interviews />} />
              <Route path='/join-our-network' element={<JoinOurNetwork />} />
              <Route path='/document-library/' element={<DocumentLibrary />} />
              <Route path='/document-library/:id' element={<BlogPostView />} />
              <Route path='/signup' element={<SignUpPage />} />
              <Route path='/whoweare' element={<WhoWeAre />} />
              <Route path='/publiccontent' element={<PublicContent />} />
              <Route path='/legalpages' element={<LawPage />} />
              <Route path='/datasource' element={<DataSourcePage />} />
              <Route path='/Signout' element={<SignoutPage />} />
              <Route path='/' element={<HomePage />} />
              <Route path='/legal-documents' element={<LegalDocuments />} />
              <Route
                path='/legal-documents/:id'
                element={<LegalDocumentTemplate />}
              />
              <Route path='/accounts' element={<ProfileCreation />} />
              <Route
                path='/accounts/:id/offices'
                element={<ProfileOfficeList />}
              />
              <Route
                path='/accounts/barrister'
                element={<BarristerCreation />}
              />
              <Route path='/accounts/law-firm' element={<LawFirmCreation />} />
              <Route
                path='/accounts/law-firm/details'
                element={<LawFirmCreationDetails />}
              />
              <Route
                path='/accounts/law-firm/manager'
                element={<LawFirmManagerCreation />}
              />
              <Route
                path='/accounts/verification'
                element={<AccountVerification />}
              />
              <Route path='/accounts/chamber' element={<ChamberCreation />} />
              <Route
                path='/accounts/chamber/manager'
                element={<ChamberManagerCreation />}
              />

              <Route
                path='/accounts/solicitor'
                element={<SolicitorCreation />}
              />
              <Route
                path='/accounts/solicitor/details'
                element={<SolicitorCreationDetails />}
              />
              <Route
                path='/accounts/solicitor/manager'
                element={<SolicitorManagerCreation />}
              />
              <Route path='/pricing' element={<Pricing />} />
              <Route
                path='/legal-terms-glossary'
                element={<LegalTermsGlossary />}
              />
              <Route
                path='/find-a-lawyer'
                element={<FindALawyerIntelligence />}
              />
              <Route
                path='/find-a-lawyer/team'
                element={<ViewTeamProfiles />}
              />
              <Route
                path='/find-a-lawyer/search'
                element={<FindALawyerIntelligenceSearch />}
              />
              <Route path='/bookalawyer' element={<BookALayer />} />
              <Route path='/profile' element={<Profile />} />
              <Route path='/appointments' element={<Appointments />} />
              <Route path='/offices/:id' element={<LawFirmResults />} />
              {/* memberEntity = solicitor, barrister, chamber, lawfirm */}
              <Route
                path='/profile/:memberEntity/:identity'
                element={<MemberProfileExtendedPage />}
              />
              <Route
                path='/lawfirms/:id/members'
                element={<LawfirmMembersList />}
              />
              <Route
                path='/legal-documents/:id/download'
                element={<LegalDocumentDownload />}
              />
              <Route path='/get-the-app' element={<GetTheAppPage />} />
              <Route path='/ourapp' element={<Ourapp />} />
              <Route path='/articles/:id' element={<ArticleDetail />} />
              <Route path='/blogs/:slug' element={<Blog />} />
              <Route
                path='/legal-documents/:id/download'
                element={<LegalDocumentDownload />}
              />

              <Route element={<ProtectedRoute isAuthenticated={!!user} />}>
                <Route path='/favourites' element={<Favourites />} />
                <Route path='/profile' element={<Profile />} />
                <Route path='/appointments' element={<Appointments />} />
                <Route path='/offices/:id' element={<LawFirmResults />} />
                {/* memberEntity = solicitor, barrister, chamber, lawfirm */}
                <Route
                  path='/profile/:memberEntity/:id'
                  element={<MemberProfileExtendedPage />}
                />
                <Route
                  path='/lawfirms/:id/members'
                  element={<LawfirmMembersList />}
                />
                <Route
                  path='/legal-documents/:id/download'
                  element={<LegalDocumentDownload />}
                />
                <Route path='/get-the-app' element={<GetTheAppPage />} />
                <Route path='/ourapp' element={<Ourapp />} />
                <Route path='/articles/:id' element={<ArticleDetail />} />
                <Route path='/blogs/:slug' element={<Blog />} />
                <Route
                  path='/legal-documents/:id/download'
                  element={<LegalDocumentDownload />}
                />
                <Route
                  path='/complaint-assistance'
                  element={<ComplaintAssistance />}
                />
                <Route element={<ProtectedRoute isAuthenticated={!!user} />}>
                  <Route path='/favourites' element={<Favourites />} />
                </Route>
                <Route path='*' element={<Error />} />
                <Route path='/our-mission' element={<OurMission />} />

                <Route path='/pricing-lawyers' element={<PricingLawyers />} />
                <Route
                  path='/top-legal-documents'
                  element={<TopLegalDocuments />}
                />
                <Route path='/ourstory' element={<OurStoryPage />} />
              </Route>
            </Routes>
          </AppLayout>
        </Router>
      </GoogleReCaptchaProvider>
    </div>
  )
}

export default App
